import React from 'react'
import { DatePicker, DatePickerProps, Field } from 'view/components/inputs'
import { isTradingDay, parseDateLike, toLocalDateString } from 'utils'
import { Market } from 'api'
import { useHolidays, useMarket } from 'view/hooks'

export interface TradingDatePickerProps extends DatePickerProps {
  currency: string | null | undefined
  dateFormat?: string
  dataTestId?: string
  market?: Market | null | undefined
}

export const TradingDatePicker = React.forwardRef((props: TradingDatePickerProps, ref: React.Ref<DatePicker>) => {
  const marketDetail = useMarket(props.market)
  const holidays = useHolidays(props.currency)
  const filterDate = (date: Date) => isTradingDay(toLocalDateString(date), holidays)

  const minDate = marketDetail?.tradeDate ? parseDateLike(marketDetail.tradeDate) : new Date()

  return <DatePicker ref={ref} filterDate={filterDate} minDate={minDate} {...props} />
})

export const TradingDatePickerField = Field(TradingDatePicker)
